import React, { useState } from "react";
import Modal from "../common/Modal";

const COLORS_BY_CATEGORY = {
  Blues: [
    "#0d47a1",
    "#1565c0",
    "#1976d2",
    "#1e88e5",
    "#2196f3",
    "#42a5f5",
    "#64b5f6",
  ],
  Greens: [
    "#1b5e20",
    "#2e7d32",
    "#388e3c",
    "#43a047",
    "#4caf50",
    "#66bb6a",
    "#81c784",
  ],
  Yellows: ["#f57f17", "#f9a825", "#fbc02d", "#fdd835", "#fff176", "#fff59d"],
  Reds: ["#570202", "#960000", "#b71c1c", "#c62828", "#d32f2f", "#e53935", "#f44336", "#ef5350"],
  Oranges: ["#e65100", "#f57c00", "#fb8c00", "#ff9800", "#ffa726"],
  Pinks: ["#880e4f", "#ad1457", "#c2185b", "#d81b60", "#e91e63", "#f06292"],
  Purples: ["#4a148c", "#6a1b9a", "#7b1fa2", "#8e24aa", "#9c27b0", "#9575cd"],
  Grays: [
    "#000000",
    "#212121",
    "#424242",
    "#616161",
    "#757575",
    "#9e9e9e",
    "#bdbdbd",
    "#e0e0e0",
    "#ffffff",
  ],
  Neutrals: ["#795548", "#a1887f", "#d7ccc8"],
};

const CATEGORY_ORDER = ["All", ...Object.keys(COLORS_BY_CATEGORY), "Custom"];

function UserColorPickerModal({ open, onClose, onSelect, selectedColor }) {
  const [customColor, setCustomColor] = useState("#ff0000");
  const [category, setCategory] = useState("All");

  function handleCustomChange(e) {
    setCustomColor(e.target.value);
    // do not call onSelect yet — wait for explicit confirmation (click preview)
  }

  return (
    <Modal show={open} title="Pick a Colour" onClose={onClose}>
      <div
        style={{
          maxHeight: "70vh",
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          //width: 'min(90vw, 640px)',
          boxSizing: "border-box",
        }}
      >
        <div className="p-4 w-full">
          <div className="mb-3 flex gap-2 flex-wrap">
            {CATEGORY_ORDER.map((cat) => (
              <button
                key={cat}
                type="button"
                className={`px-2 py-1 rounded text-sm ${
                  category === cat
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 dark:bg-gray-700"
                }`}
                onClick={() => setCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
          <div
            className="p-1 w-full"
            style={{ maxHeight: "calc(70vh - 6rem)", overflowY: "auto" }}
          >
            <div className="p-1 w-full" style={{ overflowY: "auto" }}>
              {category === "Custom" ? (
                <div className="flex flex-col gap-3 mx-auto mt-4">
                  <div className="text-center font-medium">Custom Colour</div>
                  <div className="text-xs text-gray-600 dark:text-gray-400">
                    Use the colour input, then click the preview to confirm
                  </div>
                  <div className="flex items-center gap-3 justify-center mt-2">
                    <input
                      type="color"
                      value={customColor}
                      onChange={handleCustomChange}
                      className="w-20 h-10 p-0 border-0"
                      aria-label="Custom color picker"
                    />
                    {/* Click the preview to confirm and close modal */}
                    <button
                      type="button"
                      onClick={() => {
                        onSelect(customColor);
                        onClose();
                      }}
                      className={`w-12 h-12 rounded-full border-2 ${
                        selectedColor === customColor
                          ? " ring ring-red-500"
                          : "border-gray-500"
                      }`}
                      aria-label="Confirm custom color"
                    >
                      <span className="sr-only">Confirm custom color</span>
                      <div
                        aria-hidden
                        style={{
                          width: "100%",
                          height: "100%",
                          backgroundColor: customColor,
                          borderRadius: "9999px",
                        }}
                      />
                    </button>
                  </div>
                </div>
              ) : (
                <div className="w-full">
                  <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-2 justify-center">
                    {(() => {
                      const colors =
                        category === "All"
                          ? Object.values(COLORS_BY_CATEGORY).flat()
                          : COLORS_BY_CATEGORY[category] || [];
                      return colors.map((c) => (
                        <button
                          type="button"
                          key={c}
                          className={`w-12 h-12 rounded-full border-2 ${
                            selectedColor === c
                              ? " ring ring-red-500"
                              : "border-gray-500"
                          }`}
                          style={{ backgroundColor: c }}
                          onClick={() => {
                            onSelect(c);
                            onClose();
                          }}
                          aria-label={c}
                        />
                      ));
                    })()}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default UserColorPickerModal;
